export default __webpack_public_path__ + "img/instruction.fe98af38.png";